// Boton primary con loading state. Usado en todos los forms de auth.
//
// Las clases salen de lib/button-styles (el vocabulario compartido con los
// popups y banners): este es el boton contra el que se comparan los demas, asi
// que no puede tener estilo propio.

import type { ButtonHTMLAttributes } from 'react';
import { btn } from '@/lib/button-styles';

interface SubmitButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  loadingLabel?: string;
}

export default function SubmitButton({
  loading,
  loadingLabel,
  disabled,
  children,
  ...rest
}: SubmitButtonProps): JSX.Element {
  return (
    <button
      type="submit"
      disabled={loading || disabled}
      aria-busy={loading ? 'true' : undefined}
      className={btn('primary', 'md', 'w-full')}
      {...rest}
    >
      {loading ? (loadingLabel ?? 'Procesando…') : children}
    </button>
  );
}
